import React from 'react';
import { SignalBadge } from '@shared/SignalBadge';
import { UrgencySignals } from '@/components/UrgencySignals/UrgencySignals';
import { ShareButton } from '@/components/_shared/buttons/ShareButton/ShareButton';
import { LikeEventButton } from '@/components/LikeEventButton/LikeEventbutton';
import { useBasicInfo } from '@/components/_shared/contexts/BasicInfoContext';
import styles from './EventSignalsBar.module.scss';

export const EventSignalsBar: React.FC = () => {
  const basicInfo = useBasicInfo();
  const isShareable = basicInfo.isShareable ?? false;

  return (
    <div className={styles.container}>
      <div className={styles.innerWrapper}>
        <div className={styles.signals}>
          <SignalBadge />
          <UrgencySignals eventId={basicInfo.id} />
        </div>
        <div className={styles.actionButtons}>
          {isShareable && (
            <ShareButton
              eventId={basicInfo.id}
              eventName={basicInfo.name}
              eventUrl={basicInfo.url}
              isShareable={isShareable}
            />
          )}
          <LikeEventButton />
        </div>
      </div>
    </div>
  );
};
